import { get, put } from 'helpers/api';
import { postMerge as postPropertyMerge } from 'components/properties/merge/api';

const listingTypesByDealType = {
  lease: ['LeaseSpaceListing'],
  sale: ['SaleListing', 'LotListing', 'CondoListing'],
};

export function searchProjects(deal, query, callback) {
  let listingTypes;
  if (deal) {
    listingTypes = listingTypesByDealType[deal.dealType];
  } else {
    listingTypes = null;
  }
  // TODO: Get path externally
  get('/backoffice/vouchers/search_projects', {
    params: {
      listingTypes,
      query
    }
  }).then(callback);
}

export async function associateListing(deal, listing, propertyId = null) {
  return put(deal.path, { listingId: listing.id, syncToPropertyId: propertyId });
}

export async function postMerge(properties, mappings) {
  return postPropertyMerge(properties.map(p => p.id), mappings);
}
